<template>
  <div class="talentq">
    <slot name="account"/>
    <slot name="project"/>
  </div>
</template>
<script>
  export default {
    name: "talentq-view"
  }
</script>
<style lang="scss" scoped>
  .talentq {

  }
</style>